import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types';

const URL_SITTER = '/v2/admin/membership-renewal-sitter';
const URL_PARENT = '/v2/admin/membership-renewal-parent';

class MembershipRenewalService {
  static membershipRenewalSitter(
    data?: Record<string, unknown>,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<unknown>> {
    return axios.post(`${URL_SITTER}`, data, config);
  }

  static membershipRenewalParent(
    data?: Record<string, unknown>,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<unknown>> {
    return axios.post(`${URL_PARENT}`, data, config);
  }
}

export { MembershipRenewalService };
